export default __webpack_public_path__ + "static/media/vm-scheduling-tab.ea8e0775.png";